import TextFieldArea from 'components/TextFieldArea';
import { arrayOf, func, object } from 'prop-types';
import { path } from 'ramda';
import React from 'react';
import InfoDialog from '../../../InfoDialog';

import ContentColumns from '../../components/ContentColumns';

const View1 = ({ documents }, { fmString, formValues, onChange }) => {
  const getValue = name => path(['rehab5', name], formValues) || '';

  const onChangeText = name => event => {
    const eventValue = path(['currentTarget', 'value'], event);
    onChange({ [name]: eventValue });
  };

  const msnqId = path(['rehab1', 'msnq'], formValues);
  const msnqDoc = msnqId ? documents.find(d => d.documentId === msnqId) : null;
  return (
    <React.Fragment>
      <ContentColumns
        firstColumn={
          <div>
            <h2>{fmString('onlineRehabilitation.rehab5.1.welcome')}</h2>
            <br />
            <span>{fmString('onlineRehabilitation.rehab5.1.text')}</span>{' '}
            {msnqDoc && <InfoDialog type="msnq" document={msnqDoc} fm={fmString} />}
            <br />
            <h3>{fmString('onlineRehabilitation.rehab5.1.subheader')}</h3>
            <br />
            <div>{fmString('onlineRehabilitation.rehab5.1.cognitiveProblems')}</div>
            <TextFieldArea
              editing
              input={{
                name: 'cognitiveProblems',
                onChange: onChangeText('cognitiveProblems'),
                value: getValue('cognitiveProblems'),
              }}
              hintLocale={`onlineRehabilitation.rehab5.1.cognitiveProblemsPlaceholder`}
              localeMessage={fmString}
              rows={4}
              viewStyle={{ width: '100%' }}
            />
            <br />
            <br />
            <div>{fmString('onlineRehabilitation.rehab5.1.cognitiveProblemsFrequency')}</div>
            <TextFieldArea
              editing
              input={{
                name: 'cognitiveProblems',
                onChange: onChangeText('cognitiveProblemsFrequency'),
                value: getValue('cognitiveProblemsFrequency'),
              }}
              hintLocale={`onlineRehabilitation.rehab5.1.cognitiveProblemsFrequencyPlaceholder`}
              localeMessage={fmString}
              rows={4}
              viewStyle={{ width: '100%' }}
            />
            <br />
          </div>
        }
      />
    </React.Fragment>
  );
};

View1.contextTypes = {
  fmString: func,
  formValues: object,
  onChange: func,
};
View1.propTypes = {
  documents: arrayOf(object),
};

export default View1;
